import ribDish from './images/most-popular/bbq-rib-dish.jpg';
import fettuccineAlfredoDish from './images/most-popular/fettuccine-alfredo-dish.jpg';
import fishAndShrimpDish from './images/most-popular/fish-shrimp-dish.jpg';
import friedJumboShrimpDish from './images/most-popular/jumbo-shrimp-dish.jpg';
import saladDish from './images/most-popular/salad-dish.jpg';
import spaghettiDish from './images/most-popular/spaghetti-dish.jpg';
import shrimpPastaDish from './images/most-popular/shrimp-pasta-dish.jpg';
import tacoDish from './images/most-popular/taco-dish.jpg';

export const mostPopularMenu = [
	{
		id: 1,
		img: ribDish,
		foodName: 'BBQ Ribs Full Rack Dish',
		calories: 2412,
		price: '$24.99'
	},
	{
		id: 2,
		img: fettuccineAlfredoDish,
		foodName: 'Fettuccine Alfredo Dish',
		calories: 1017,
		price: '$11.99'
	},
	{
		id: 3,
		img: fishAndShrimpDish,
		foodName: 'Battered Fish & Shrimp Dish',
		calories: 1789,
		price: '$18.99'
	},
	{
		id: 4,
		img: friedJumboShrimpDish,
		foodName: 'Battered Jumbo Shrimp Dish',
		calories: 700,
		price: '$12.99'
	},
	{
		id: 5,
		img: saladDish,
		foodName: 'Grilled Chicken Salad Dish',
		calories: 451,
		price: '$10.99'
	},
	{
		id: 6,
		img: spaghettiDish,
		foodName: 'Baked Spaghetti Dish',
		calories: 856,
		price: '$12.99'
	},
	{
		id: 7,
		img: shrimpPastaDish,
		foodName: 'Shrimp Pasta Dish',
		calories: 1048,
		price: '$17.99'
	},
	{
		id: 8,
		img: tacoDish,
		foodName: 'Beefy Mini Taco Dish',
		calories: 797,
		price: '$15.99'
	}
];
